import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import AddButton from "components/ui/Button/AddButton/AddButton";
import { CANNED_RESPONSE_UPDATE_PERMISSION } from "components/dashboard/KnowledgeBase/CannedResponses/permissions";

const EditCRButton = ({ onClick }) => {
    return (
        <div>
            <ComponentAccessControl
                baseResources={CANNED_RESPONSE_UPDATE_PERMISSION}>
                <AddButton btnText={`Edit`} hasIcon={false} onClick={onClick} />
            </ComponentAccessControl>
        </div>
    );
};

export default EditCRButton;
